export default "__VITE_ASSET__DLbE7kXs__"